import i18n from 'i18next'

import { checkIsLowEnv } from 'Core/env'
import { initI18Next } from 'Core/utils/i18Next'

import { RESOURCES } from './constants'

initI18Next({ i18next: i18n, resources: RESOURCES, isLocizeEnabled: checkIsLowEnv() })

export default i18n
